import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import {
  FETCH_CONFIGURABLES_REQUEST,
  fetchConfigurablesSuccess,
  fetchConfigurablesFailure,
  UPDATE_CONFIGURABLE_REQUEST,
  updateConfigurableSuccess,
  updateConfigurableFailure,
} from '../actions/configActions';

import { getBaseUrl } from '../utils/getBaseUrl';

// Helper function to get the auth token from localStorage
const getAuthToken = () => localStorage.getItem('authToken');
const API_BASE_URL = getBaseUrl();

// Worker Saga: Fetch Configurables
function* fetchConfigurables() {
  try {
    const token = getAuthToken();
    const response = yield call(axios.get, `${API_BASE_URL}/api/configurables`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    yield put(fetchConfigurablesSuccess(response.data));
  } catch (error) {
    yield put(fetchConfigurablesFailure(error.response?.data?.message || error.message));
  }
}

// Worker Saga: Update Configurable
function* updateConfigurable(action) {
  try {
    const token = getAuthToken();
    const { key, value } = action.payload;
    const response = yield call(
      axios.put,
      `${API_BASE_URL}/api/configurables`,
      { key, value },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    yield put(updateConfigurableSuccess({ key, value }));
  } catch (error) {
    yield put(updateConfigurableFailure(error.response?.data?.message || error.message));
  }
}

// Watcher Saga
function* configSaga() {
  yield takeLatest(FETCH_CONFIGURABLES_REQUEST, fetchConfigurables);
  yield takeLatest(UPDATE_CONFIGURABLE_REQUEST, updateConfigurable);
}

export default configSaga;
